/**
 *
 * Important - should only be used when unable to get an injection context or when outside of the host-app project; otherwise inject the config as usual.
 *
 * Access the view transition config from the window object, outside of an injection context.
 *
 * Should only be called after the vanilla/core bootloader has run.
 *
 * @returns true if view transitions are enabled.
 *
 * @throws if the host app config is not available.
 */
export function isViewTransitionsEnabled(): boolean {
    return !!(window as typeof window & { clientConfig: { haUi: { viewTransitionsEnabled: boolean } } })?.clientConfig?.haUi?.viewTransitionsEnabled;
}
